import React, { useEffect, useRef } from 'react';

import { throttle } from 'lodash-es';

import { SeturIcon } from '@components/utils/CustomIcon';
import { getOffset } from '@utils/getElementOffset';

import { Container } from './styled';
import ScrollLink from './Link';

interface TabItems {
  key: string;
  title: string;
  icon?: SeturIcon;
  show?: boolean;
}

interface TabProps {
  tabs: TabItems[];
}

const Tab = ({ tabs }: TabProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  //register the scroll event listener callback function
  useEffect(() => {
    // scroll event callback function
    const onScroll = throttle(() => {
      const activeTabItem = containerRef?.current?.querySelector('.active');

      if (activeTabItem) {
        const activeTabOffset = getOffset(activeTabItem);

        const isInView =
          activeTabOffset.left >= 0 &&
          activeTabOffset.left + (activeTabItem.clientWidth ?? 0) <=
            window.innerWidth;

        if (isInView) return;
        containerRef?.current?.scrollTo({
          left: activeTabOffset.left,
          top: activeTabOffset.top,
          behavior: 'smooth',
        });
      }
    }, 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <Container ref={containerRef}>
      {tabs?.map((tab) =>
        tab.show ? (
          <ScrollLink key={tab.key} className={tab.key} to={tab.key}>
            {tab.title}
          </ScrollLink>
        ) : null
      )}
    </Container>
  );
};

export default Tab;
